/** 审批中心深链导航：同页跳转时附带 _r 以触发列表刷新 */

export function isApprovalCenterLink(link) {
  const path = (link || '').split('?')[0];
  return path === '/approval-center' || path.endsWith('/approval-center');
}

export function buildApprovalCenterSearch(linkPath, overrides = {}) {
  const raw = linkPath || '';
  let params;
  if (raw.includes('?')) {
    params = new URLSearchParams(raw.split('?')[1]);
  } else {
    params = new URLSearchParams();
    if (overrides.tab) params.set('tab', overrides.tab);
  }
  if (overrides.taskId && !params.has('taskId')) {
    params.set('taskId', String(overrides.taskId));
  }
  params.set('_r', String(Date.now()));
  return `?${params.toString()}`;
}

export function withApprovalCenterRefresh(link) {
  if (!link || !isApprovalCenterLink(link)) return link;
  const pathname = link.split('?')[0];
  return `${pathname}${buildApprovalCenterSearch(link)}`;
}

export function navigateToLink(navigate, link) {
  if (!link) return;
  const finalLink = withApprovalCenterRefresh(link);
  if (finalLink.includes('?')) {
    const [pathname, search] = finalLink.split('?');
    navigate({ pathname, search: `?${search}` });
  } else {
    navigate(finalLink);
  }
}

export function navigateToApprovalCenter(navigate, linkPath, overrides = {}) {
  navigate({
    pathname: '/approval-center',
    search: buildApprovalCenterSearch(linkPath, overrides)
  });
}
